import React from 'react';
import { Briefcase, Users, Clock } from 'lucide-react';
export const InfoCards = () => {
  return <div className="grid grid-cols-4 gap-4 p-4" data-id="element-747">
      <InfoCard title="Date of Joining" value="Nov, 2022" subvalue="2 Years" icon={<Clock className="h-6 w-6 text-white" data-id="element-749" />} iconBg="bg-red-500" data-id="element-748" />
      <InfoCard title="Active Delegations" value="0" icon={<Users className="h-6 w-6 text-white" data-id="element-751" />} iconBg="bg-pink-400" data-id="element-750" />
      <InfoCard title="Fetching location..." actionButton={<button className="px-4 py-1 border border-gray-300 rounded-full text-sm font-medium" data-id="element-753">
            Activate
          </button>} icon={null} iconBg="bg-blue-400" data-id="element-752" />
      <InfoCard title="Upcoming Prayer" value="Asr" subvalue="15:52 PM" icon={null} iconBg="bg-purple-400" bgPattern={true} data-id="element-754" />
    </div>;
};
const InfoCard = ({
  title,
  value,
  subvalue,
  icon,
  iconBg,
  actionButton,
  bgPattern
}) => {
  return <div className={`bg-white rounded-lg shadow-sm p-4 relative overflow-hidden ${bgPattern ? 'bg-opacity-90' : ''}`} data-id="element-755">
      {bgPattern && <div className="absolute inset-0 opacity-10" data-id="element-756">
          <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-757">
            <pattern id="pattern-circles" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" patternContentUnits="userSpaceOnUse" data-id="element-758">
              <circle id="pattern-circle" cx="10" cy="10" r="5" fill="#f97316" data-id="element-759" />
            </pattern>
            <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern-circles)" data-id="element-760" />
          </svg>
        </div>}
      <div className="flex justify-between items-start" data-id="element-761">
        <div data-id="element-762">
          <h3 className="text-gray-600 text-sm mb-1" data-id="element-763">{title}</h3>
          {value && <p className="text-gray-800 font-bold text-lg" data-id="element-764">{value}</p>}
          {subvalue && <p className="text-gray-500 text-sm" data-id="element-765">{subvalue}</p>}
          {actionButton && <div className="mt-2" data-id="element-766">{actionButton}</div>}
        </div>
        {icon !== null && <div className={`${iconBg} h-10 w-10 rounded-full flex items-center justify-center`} data-id="element-767">
            {icon}
          </div>}
      </div>
    </div>;
};